// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ff46aade","453":"c1089b44","551":"c1cc4343","851":"0f795a9e"}[chunkId] + ".chunk.js";
};